import {createSelector} from '@reduxjs/toolkit'

import {State as DetailsState} from './detailsSlice'
import {RootState} from './store'

const detailsSelector = (state: RootState): DetailsState => state.details

//State selectors
export const selectErrorMessage = createSelector(
  detailsSelector,
  (state) => state.errorMessage
)

export const selectImageError = createSelector(
  detailsSelector,
  (state) => state.imageError
)

export const selectIsDGCP = createSelector(
  detailsSelector,
  (state) => state.isDGCP
)

export const selectIsUnauthorized = createSelector(
  detailsSelector,
  (state) => state.isUnauthorized
)

export const selectLoading = createSelector(
  detailsSelector,
  (state) => state.loading
)

export const selectSupportLevel = createSelector(
  detailsSelector,
  (state) => state.supportLevel
)

export const selectTicketNumber = createSelector(
  detailsSelector,
  (state) => state.ticketNumber
)

// Detail selectors
export const selectAppKey = createSelector(
  detailsSelector,
  (state) => state.details.appKey
)

export const selectAppName = createSelector(
  detailsSelector,
  (state) => state.details.appName
)

export const selectBrowser = createSelector(
  detailsSelector,
  (state) => state.details.browser
)

export const selectBrowserVersion = createSelector(
  detailsSelector,
  (state) => state.details.browserVersion
)

export const selectChannelId = createSelector(
  detailsSelector,
  (state) => state.details.channelId
)

export const selectDetails = createSelector(
  detailsSelector,
  (state) => state.details
)

export const selectMessageName = createSelector(
  detailsSelector,
  (state) => state.details.messageName
)

export const selectMessageType = createSelector(
  detailsSelector,
  (state) => state.details.messageType
)

export const selectProductLabel = createSelector(
  detailsSelector,
  (state) => state.details.productLabel
)

export const selectProjectId = createSelector(
  detailsSelector,
  (state) => state.details.projectId
)

export const selectProjectName = createSelector(
  detailsSelector,
  (state) => state.details.projectName
)

export const selectPushId = createSelector(
  detailsSelector,
  (state) => state.details.pushId
)

export const selectSDKFramework = createSelector(
  detailsSelector,
  (state) => state.details.sdkFramework
)

export const selectSDKFrameworkVersion = createSelector(
  detailsSelector,
  (state) => state.details.sdkFrameworkVersion
)

export const selectUrl = createSelector(
  detailsSelector,
  (state) => state.details.url
)
